import { createContext, useState, useEffect } from "react";
import { Axios } from "../App";

export const UserContext = createContext();

export const UserContextProvider = ({ children }) => {
  const [theUser, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [wait, setWait] = useState(false);

  const registerUser = async ({ name, email, password }) => {
    setWait(true);
    try {
      const { data } = await Axios.post("register.php", {
        name,
        email,
        password,
      });
      setWait(false);
      return data;
    } catch (err) {
      setWait(false);
      return { success: 0, message: "Server Error!" };
    }
  };

  const loginUser = async ({ email, password }) => {
    setIsLoading(true);
    setWait(true);
    try {
      const { data } = await Axios.post("login.php", {
        email,
        password,
      });
      if (data.success && data.token) {
        localStorage.setItem("loginToken", data.token);
        setWait(false);
        setIsLoading(false);
        return { success: 1 };
      }
      setWait(false);
      setIsLoading(false);
      return { success: 0, message: data.message };
    } catch (err) {
      setIsLoading(false);
      setWait(false);
      return { success: 0, message: "Server Error!" };
    }
  };

  const loggedInCheck = async () => {
    setIsLoading(true);
    const loginToken = localStorage.getItem("loginToken");
    // Axios.defaults.headers.common['Authorization'] = 'Bearer ' + loginToken;
    if (loginToken) {
      const { data } = await Axios.get("getUser.php");
      if (data.success && data.user) {
        setUser(data.user);
        setIsLoading(false);
        return;
      }
      setUser(null);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    async function asyncCall() {
      await loggedInCheck();
    }
    asyncCall();
  }, []);

  const logout = () => {
    localStorage.removeItem("loginToken");
    setUser(null);
  };

  return (
    <UserContext.Provider
      value={{
        registerUser,
        loginUser,
        wait,
        user: theUser,
        loggedInCheck,
        logout,
        isLoading,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserContextProvider;
